import React, { useState } from 'react';
import styles from './Slider.module.css';

const Slider = ({
  min,
  max,
  step,
  value,
  onChange,
  onCommit,
  disabled,
  label,
  mixed,
  showValue = true,
}) => {
  const [isDragging, setIsDragging] = useState(false);

  const handlePointerUp = () => {
    if (isDragging) {
      setIsDragging(false);
      if (onCommit) {
        onCommit();
      }
    }
  };

  return (
    <div className={styles.wrapper}>
      {label && <div className={styles.label}>{label}</div>}
      <div className={styles.sliderRow}>
        <input
          type="range"
          min={min}
          max={max}
          step={step}
          value={mixed ? (min + max) / 2 : value}
          className={`${styles.slider} ${mixed ? styles.mixed : ''}`}
          onChange={(event) => onChange(Number(event.target.value))}
          onMouseDown={() => setIsDragging(true)}
          onTouchStart={() => setIsDragging(true)}
          onMouseUp={handlePointerUp}
          onTouchEnd={handlePointerUp}
          onBlur={handlePointerUp}
          disabled={disabled}
        />
        {showValue && (
          <div className={styles.value}>
            {mixed ? 'Mixed' : value}
          </div>
        )}
      </div>
    </div>
  );
};

export default Slider;
